import {
  BAR_DEFAULT_DATA_URL,
  CHART_TYPES,
  DONUT_DEFAULT_DATA_URL,
  LINE_DEFAULT_DATA_URL,
  PIE_DEFAULT_DATA_URL,
} from '../../containers/ComplexDocumentDesign/CreativeBlockDesign/Charts/chartConstants';
import { ELEMENT_TYPES } from '../complexDocumentConstants';
import { CHARTS_MASTER_ELEMENTS as trans } from './translationValues';

export const chartElements = t => {
  return [
    {
      id: 1130,
      type: 'plain',
      categoryId: 186,
      shareType: null,
      thumbnail: '/pie-chart.svg',
      name: t(trans.PIE_CHART.key, trans.PIE_CHART.value),
      tags: null,
      resourceGroup: 0,
      permission: 'write',
      referenced: false,
      element: {
        tagValue: '/pie-chart.svg',
        uiType: 'pieChart',
        styles: {
          backgroundColor: 'transparent',
          transform: 'translateX(1) translateY(1) rotate(0deg) scaleX(1) scaleY(1)',
          position: 'absolute',
          width: '200px',
          height: '200px',
        },
        type: ELEMENT_TYPES.CHART,
        tagName: 'image',
        value: '/square.svg',
        tagStyles: {
          scaleX: 1,
          scaleY: 1,
          rotate: 0,
          backgroundColor: [255, 255, 255, 1],
          translateY: 219,
          translateX: 24.75848388671875,
          width: '214',
          height: '214',
        },
        chartDetails: {
          type: CHART_TYPES.PIE,
          dataSource: [
            {
              label: 'Item 1',
              value: '20',
              description: 'item 1 description',
              color: [244, 182, 30],
            },
            {
              label: 'Item 2',
              value: '50',
              description: 'item 2 description',
              color: [187, 216, 179],
            },
            {
              label: 'Item 3',
              value: '20',
              description: 'item 3 description',
              color: [139, 173, 168],
            },
            {
              label: 'Item 4',
              value: '30',
              description: 'item 4 description',
              color: [49, 53, 110],
            },
            {
              label: 'Item 5',
              value: '40',
              description: 'item 5 description',
              color: [255, 222, 89],
            },
          ],
          showLegend: false,
          showLabels: true,
          legendPosition: 'bottom',
          formatValueType: 'percentage',
          dataUrl: PIE_DEFAULT_DATA_URL,
          fontFamily: 'Open Sans',
          labelFontSize: 35,
          valueFontSize: 39,
          descriptionFontSize: 29,
          labelColor: [0, 0, 0],
          valueColor: [0, 0, 0],
          descriptionColor: [0, 0, 0],
          chartStyle: 'outside',
          baseVariable: 'chartVar',
          labelVariable: undefined,
          valueVariable: undefined,
          descVariable: undefined,
          colorPalette: [],
        },
      },
      groupId: null,
      language: null,
      elementJson: {
        empty: false,
      },
    },
    {
      id: 1131,
      type: 'plain',
      categoryId: 186,
      shareType: null,
      thumbnail: '/donut-chart.svg',
      name: t(trans.DONUT_CHART.key, trans.DONUT_CHART.value),
      tags: null,
      resourceGroup: 0,
      permission: 'write',
      referenced: false,
      element: {
        tagValue: '/donut-chart.svg',
        uiType: 'donutChart',
        styles: {
          backgroundColor: 'transparent',
          transform: 'translateX(1) translateY(1) rotate(0deg) scaleX(1) scaleY(1)',
          position: 'absolute',
          width: '200px',
          height: '200px',
        },
        type: ELEMENT_TYPES.CHART,
        tagName: 'image',
        value: '/square.svg',
        tagStyles: {
          scaleX: 1,
          scaleY: 1,
          rotate: 0,
          backgroundColor: [255, 255, 255, 1],
          translateY: 219,
          translateX: 24.75848388671875,
          width: '214',
          height: '214',
        },
        chartDetails: {
          type: CHART_TYPES.DONUT,
          dataSource: [
            {
              label: 'Item 1',
              value: '20',
              description: 'item 1 description',
              color: [244, 182, 30],
            },
            {
              label: 'Item 2',
              value: '50',
              description: 'item 2 description',
              color: [187, 216, 179],
            },
            {
              label: 'Item 3',
              value: '20',
              description: 'item 3 description',
              color: [139, 173, 168],
            },
            {
              label: 'Item 4',
              value: '30',
              description: 'item 4 description',
              color: [49, 53, 110],
            },
            {
              label: 'Item 5',
              value: '40',
              description: 'item 5 description',
              color: [255, 222, 89],
            },
          ],
          showLegend: false,
          showLabels: true,
          legendPosition: 'bottom',
          formatValueType: 'percentage',
          dataUrl: DONUT_DEFAULT_DATA_URL,
          fontFamily: 'Open Sans',
          labelFontSize: 35,
          valueFontSize: 39,
          descriptionFontSize: 29,
          labelColor: [0, 0, 0],
          valueColor: [0, 0, 0],
          descriptionColor: [0, 0, 0],
          chartStyle: 'outside',
          baseVariable: 'chartVar',
          labelVariable: undefined,
          valueVariable: undefined,
          descVariable: undefined,
          colorPalette: [],
        },
      },
      groupId: null,
      language: null,
      elementJson: {
        empty: false,
      },
    },
    {
      id: 1133,
      type: 'plain',
      categoryId: 186,
      shareType: null,
      thumbnail: '/line-chart.svg',
      name: t(trans.LINE_CHART.key, trans.LINE_CHART.value),
      tags: null,
      resourceGroup: 0,
      permission: 'write',
      referenced: false,
      element: {
        tagValue: '/line-chart.svg',
        uiType: 'lineChart',
        styles: {
          backgroundColor: 'transparent',
          transform: 'translateX(1) translateY(1) rotate(0deg) scaleX(1) scaleY(1)',
          position: 'absolute',
          width: '200px',
          height: '200px',
        },
        type: ELEMENT_TYPES.CHART,
        tagName: 'image',
        value: '/square.svg',
        tagStyles: {
          scaleX: 1,
          scaleY: 1,
          rotate: 0,
          backgroundColor: [255, 255, 255, 1],
          translateY: 219,
          translateX: 24.75848388671875,
          width: '214',
          height: '214',
        },
        chartDetails: {
          type: CHART_TYPES.LINE,
          labels: ['Item 1', 'Item 2', 'Item 3', 'Item 4'],
          seriesList: [
            { name: 'Series 1', series: ['30', '40', '67', '75'], color: [244, 182, 30] },
            { name: 'Series 2', series: ['10', '50', '56', '85'], color: [187, 216, 179] },
            { name: 'Series 3', series: ['10', '40', '59', '85'], color: [49, 53, 110] },
          ],
          showLegend: false,
          showLabels: true,
          showGrid: false,
          legendPosition: 'bottom',
          orientation: 'vertical',
          prefixValue: '',
          suffixValue: '',
          valueInterval: 10,
          dataUrl: LINE_DEFAULT_DATA_URL,
          fontFamily: 'Open Sans',
          labelFontSize: 35,
          valueFontSize: 39,
          legendFontSize: 35,
          labelColor: [0, 0, 0],
          valueColor: [0, 0, 0],
          legendColor: [0, 0, 0],
          chartStyle: 'normal',
          baseVariable: 'chartVar',
          labelVariable: undefined,
          seriesNameVariable: undefined,
          seriesValueVariable: undefined,
          colorPalette: [],
        },
      },
      groupId: null,
      language: null,
      elementJson: {
        empty: false,
      },
    },
    {
      id: 1132,
      type: 'plain',
      categoryId: 186,
      shareType: null,
      thumbnail: '/bar-chart.svg',
      name: t(trans.BAR_CHART.key, trans.BAR_CHART.value),
      tags: null,
      resourceGroup: 0,
      permission: 'write',
      referenced: false,
      element: {
        tagValue: '/bar-chart.svg',
        uiType: 'barChart',
        styles: {
          backgroundColor: 'transparent',
          transform: 'translateX(1) translateY(1) rotate(0deg) scaleX(1) scaleY(1)',
          position: 'absolute',
          width: '200px',
          height: '200px',
        },
        type: ELEMENT_TYPES.CHART,
        tagName: 'image',
        value: '/square.svg',
        tagStyles: {
          scaleX: 1,
          scaleY: 1,
          rotate: 0,
          backgroundColor: [255, 255, 255, 1],
          translateY: 219,
          translateX: 24.75848388671875,
          width: '214',
          height: '214',
        },
        chartDetails: {
          type: CHART_TYPES.BAR,
          labels: ['Item 1', 'Item 2', 'Item 3'],
          seriesList: [
            { name: 'January', series: ['10', '20', '30'], color: [244, 182, 30] },
            { name: 'February', series: ['30', '10', '20'], color: [187, 216, 179] },
            { name: 'March', series: ['20', '30', '10'], color: [49, 53, 110] },
          ],
          showLegend: false,
          showLabels: true,
          showGrid: false,
          legendPosition: 'bottom',
          orientation: 'vertical',
          prefixValue: '',
          suffixValue: '',
          valueInterval: 10,
          dataUrl: BAR_DEFAULT_DATA_URL,
          fontFamily: 'Open Sans',
          labelFontSize: 35,
          valueFontSize: 39,
          legendFontSize: 35,
          labelColor: [0, 0, 0],
          valueColor: [0, 0, 0],
          legendColor: [0, 0, 0],
          chartStyle: 'normal',
          baseVariable: 'chartVar',
          labelVariable: undefined,
          seriesNameVariable: undefined,
          seriesValueVariable: undefined,
          colorPalette: [],
        },
      },
      groupId: null,
      language: null,
      elementJson: {
        empty: false,
      },
    },
  ];
};
